import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { BootData } from 'webapp/data-loader/base';
import DataLoaderBase from 'webapp/data-loader/base';

import type E2ESeedService from 'webapp/services/e2e-seed';

export default class DataLoaderE2ESeed extends DataLoaderBase {
	@service('e2e-seed') declare e2eSeedService: E2ESeedService;

	@tracked override initialRequestsDone = false;
	initialRequestsPromise: Promise<void>;

	constructor(...args: ConstructorParameters<typeof DataLoaderBase>) {
		super(...args);

		this.initialRequestsPromise = new Promise((resolve) => {
			this.resolveInitialRequestsPromiseFn = resolve;
		});

		this.e2eSeedService.setBaseGlobals();
		this.e2eSeedService.seedGlobals();
	}

	markInitialRequestsReady() {
		this.markInitialRequestsPromiseAsResolved();
	}

	loadGlobals(_bootData: BootData): void {
		// Globals are supplied later via the e2e-seed service, not coredata.
	}

	doInitialRequests(): Promise<void> {
		return Promise.resolve(); // non-blocking; resolved externally via markInitialRequestsReady
	}

	afterInitialRequests(_initialRouteTo: string): Promise<void> {
		return Promise.resolve();
	}
}
